(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/models/best-rows-match-list-item.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/models/best-rows-match-list-item.js'); 'use strict';

svs.sport.best_rows.models.BestRowsMatchListItem = Backbone.Model.extend({
  defaults: {
    eventNumber: '0',
    eventDescription: '-',
    homeTeamGoals: '0',
    awayTeamGoals: '0',
    outcome: 'X',
    cancelled: 0,
    mode: 'matcher',
    svenskaFolket: {
      one: '0',
      two: '0',
      x: '0'
    }
  }
});
 })(window);